import { render, staticRenderFns } from "./semester-view.vue?vue&type=template&id=10e213f9&"
import script from "./semester-view.vue?vue&type=script&lang=js&"
export * from "./semester-view.vue?vue&type=script&lang=js&"
import style0 from "./semester-view.vue?vue&type=style&index=0&id=10e213f9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports